import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

interface SendMessagePayload {
  message: string
  type: 'sms' | 'email'
  address: string
}

/**
 * Send an e-mail/sms
 *
 * @private
 */
export const sendMessage = createAsyncThunk<
  // Return type of the payload creator
  boolean,
  // First argument to the payload creator
  SendMessagePayload,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/driver/sendMessage', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()
    const response = await rpc('rpc/driver/sendMessage', {
      category: 'rpc',
      type: 'rpc/driver/sendMessage',
      payload,
    })

    if (response.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: response.errorMessage,
        error: response,
      })
    }

    return response.result
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {sendMessage}`,
      { tags: ['rpc', 'driver'], info: payload },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Send message to ${payload.address} Failed`,
      error,
    })
  }
})
